export default {
  title: 'Detalhes do pedido',
  order_again: 'Pedir novamente',
};
